import { Injectable } from "@angular/core";
import { CreateBookingWS } from "@app/core/booking/data/network/create-booking.ws";
import { BookingRepo } from "@app/core/booking/domain/booking-repo";
import { Booking } from "@app/core/booking/domain/model/booking";
import { ShareMessageRepo } from "@app/core/share-message/domain/share-message.repo";
import { ShareMessageCapacitor } from "@app/core/share-message/infrastructure/capacitor/share-message.capacitor";

import { Observable } from "rxjs";

@Injectable()
export class ShareMessageCapacitorImplRepo implements ShareMessageRepo {
  constructor(private shareMessageCapacitor: ShareMessageCapacitor) {}

  shareMessage(message: string, url: string): Observable<string> {
    return this.shareMessageCapacitor.execute(message, url);
  }
}
